import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import { DatePicker, DatePickerProps } from "@material-ui/pickers";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import { animated } from "react-spring/renderprops-universal";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface PromptedDatePickerProps extends DatePickerProps {
	title: string;
}

const PromptedDatePicker = React.forwardRef<
	HTMLInputElement,
	PromptedDatePickerProps & WithStyles<typeof styles>
>(({ title, classes, className, ...datePickerProps }, ref) => {
	return (
		<Tooltip title={title} placement="top" arrow>
			<DatePicker
				{...datePickerProps}
				inputVariant="outlined"
				fullWidth
				size="small"
				format="DD/MM/yyyy"
			/>
		</Tooltip>
	);
});

const StyledPromptedDatePicker = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("PromptedDatePicker"),
})(PromptedDatePicker);

export default StyledPromptedDatePicker;

export const AnimatedPromptedDatePicker = animated(StyledPromptedDatePicker);
